import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyAnyO-q_9mKnIpqToJa7m2D9HzTCtcX8m8",
  authDomain: "smart-travel-dev-7f3ed.firebaseapp.com",
  projectId: "smart-travel-dev-7f3ed",
  storageBucket: "smart-travel-dev-7f3ed.firebasestorage.app",
  messagingSenderId: "588996108497",
  appId: "1:588996108497:web:3ddeb9234127a6eecee5f0",
  measurementId: "G-65S5R7BL38",
};

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const auth = getAuth(app);
const storage = getStorage(app);
export { db, auth, storage };
